module.exports = __webpack_public_path__ + "img/yyjz.fe027e82.png";